import { useState, useEffect } from "react";
import Box from "../Box";
import AlertBox from "../AlertBox";
import { updateSettingByKey } from "../../api/setting";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import { useWAProviderSettingHooks } from "../../utils/WASettingUtils";

export default function BoxWAProvider() {
  let { hasAccess } = useControlPermission();

  let { data, fetched, loading: dataLoading, getWaProviderSettings } = useWAProviderSettingHooks();
  let [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [forms, setForms] = useState("");
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (fetched) {
      let defaultForms = data.value;
      setForms(defaultForms);
    }
  }, [fetched, data]);

  const sendData = async (form) => {
    setLoading(true);
    try {
      let response = await updateSettingByKey("whatsapp-notification-provider", form);
      setAlert({ show: true, message: response.data.message, type: "success" });
      getWaProviderSettings();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  const submitData = (event) => {
    event.preventDefault();

    let formData = {};
    formData["whatsapp-notification-provider"] = forms;

    sendData(formData);
  };

  const changeValueForm = (value) => {
    setForms(value);
  };

  return (
    <Box title="Setting Notifikasi WhatsApp" loading={dataLoading || loading}>
      <AlertBox {...alert} setAlert={setAlert} />
      <form onSubmit={(event) => submitData(event)}>
        <div className="form-group">
          <label>WhatsApp Provider:</label>
          <select
            className="form-control"
            value={forms}
            onChange={(event) => changeValueForm(event.target.value)}
          >
            <option value="" disabled>
              -- Pilih Provider --
            </option>
            <option value="qiscus">Qiscus</option>
            <option value="qontak">Mekari Qontak</option>
          </select>
        </div>
        {hasAccess("update-setting") && (
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary">Simpan Perubahan</button>
          </div>
        )}
      </form>
    </Box>
  );
}
